import { createApp, provide, h } from "vue";
import { createPinia } from "pinia";
import { apolloClient } from "./apollo"; // ✅ เพิ่ม { }
import { DefaultApolloClient } from "@vue/apollo-composable";
import router from "./router";
import App from "./App.vue";
import "normalize.css";

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  render: () => h(App),
});

app.use(createPinia());
app.use(router);
app.mount("#app");
